/* Auvra v4.0 PDP extras (10 Sep 2026): Save-£ pill sync, cross-sell ajax add → cart drawer,
   review quote prev/next, keyboard-accessible tabs. Vanilla, no deps. Variant logic, gallery
   and the sticky toggle stay in assets/auvra-pdp.js. */
(function () {
  'use strict';
  if (window.__auvraV4Pdp) return; /* loaded by the main product section and the tabs section: run once */
  window.__auvraV4Pdp = true;

  /* ---- (d) "Save £X" pill: follow [data-price-target] rewrites from auvra-pdp.js ---- */
  function parseMoney(txt) {
    var n = parseFloat(String(txt || '').replace(/[^\d.,]/g, '').replace(/,/g, ''));
    return isNaN(n) ? null : n;
  }
  function currencyPrefix(txt) {
    var m = String(txt || '').match(/^[^\d]*/);
    return m ? m[0].trim() : '£';
  }
  document.querySelectorAll('.av-pricerow').forEach(function (row) {
    var target = row.querySelector('[data-price-target]');
    var pill = row.querySelector('[data-av-save]');
    if (!target || !pill) return;
    function sync() {
      var was = target.querySelector('s');
      var now = target.querySelector('strong');
      var w = was ? parseMoney(was.textContent) : null;
      var n = now ? parseMoney(now.textContent) : null;
      if (w != null && n != null && w > n) {
        var sym = currencyPrefix(now.textContent);
        pill.textContent = 'Save ' + sym + (w - n).toFixed(2); /* v5.1: always £X.XX, matching the Liquid render */
        pill.hidden = false;
      } else {
        pill.hidden = true;
        pill.textContent = '';
      }
    }
    new MutationObserver(sync).observe(target, { childList: true, subtree: true, characterData: true });
    sync();
  });

  /* ---- (i) cross-sell "+ Add": ajax add, refresh + open the cart drawer ---- */
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-av-xsell-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var idEl = form.querySelector('[name="id"]');
    if (!idEl) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    } else if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      sections = cartItems.getSectionsToRender().map(function (s) { return s.section; });
    }
    var body = { items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { throw new Error(state.description || 'error'); }
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state); /* Dawn: re-renders and opens the drawer */
        } else {
          window.location.href = root() + 'cart';
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auvra-v4-xsell', cartData: state }); } catch (err) {}
        }
        if (btn) { btn.disabled = false; btn.textContent = '✓ Added'; btn.classList.add('is-added'); }
        setTimeout(function () { if (btn) { btn.textContent = btn.getAttribute('data-label') || '+ Add'; btn.classList.remove('is-added'); } }, 2500);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || '+ Add'; }
      });
  });

  /* ---- (j) review quote card: prev / next over the real reviews ---- */
  document.querySelectorAll('[data-av-quote]').forEach(function (q) {
    var wrap = q.querySelector('.av-quote__slides');
    var slides = Array.prototype.slice.call(q.querySelectorAll('[data-av-quote-slide]'));
    var prev = q.querySelector('[data-av-quote-prev]');
    var next = q.querySelector('[data-av-quote-next]');
    var count = q.querySelector('[data-av-quote-count]');
    var nav = q.querySelector('.av-quote__nav');
    if (!wrap || !slides.length) { q.hidden = true; return; }
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    wrap.classList.add('is-init');
    show(0);
    if (slides.length < 2) { if (nav) nav.hidden = true; return; }
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
  });

  /* ---- (B3) sticky buy card, belt-and-braces: auvra-pdp.js toggles .is-visible via an
     IntersectionObserver on [data-sticky-sentinel]; this throttled scroll listener also shows the
     card whenever the main Add to Basket has scrolled above the viewport (anchor jumps, sentinel
     hidden, IO not firing). Keeps aria-hidden + tabindex in step exactly like auvra-pdp.js. ---- */
  (function () {
    var sticky = document.querySelector('[data-auvra-sticky]');
    var atc = document.querySelector('.auvra-pdp__atc');
    if (!sticky || !atc) return;
    var ticking = false;
    function apply(show) {
      if (show === sticky.classList.contains('is-visible')) return;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.querySelectorAll('button, a, input, select').forEach(function (el) {
        if (show) { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', '-1'); }
      });
    }
    function check() {
      ticking = false;
      apply(atc.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('hashchange', function () { setTimeout(check, 50); });
    window.addEventListener('load', check);
    check();
  })();

  /* ---- (B5) tabs: WAI-ARIA tab pattern (arrow keys, Home/End, roving tabindex) ---- */
  document.querySelectorAll('[data-av-tabs]').forEach(function (tabs) {
    var list = tabs.querySelector('[role="tablist"]');
    var btns = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(tabs.querySelectorAll('[role="tabpanel"]'));
    if (!list || !btns.length) return;
    function activate(idx, focus) {
      btns.forEach(function (b, k) {
        var on = k === idx;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        b.classList.toggle('is-active', on);
        if (on && focus) b.focus();
      });
      panels.forEach(function (p, k) { p.hidden = k !== idx; });
    }
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () { activate(k, false); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (k + 1) % btns.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (k - 1 + btns.length) % btns.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = btns.length - 1;
        if (n !== null) { e.preventDefault(); activate(n, true); }
      });
    });
    var start = btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
    activate(start < 0 ? 0 : start, false);
  });
})();
